"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styles = theme => {
  return {
    wrapper: {
      paddingTop: theme.spacing(2),
      paddingBottomTop: theme.spacing(8),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    btn: {
      padding: theme.spacing(0),
      width: '2rem',
      minWidth: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#3F4B5F',
      color: '#E0E4ED',
      borderRadius: 4,
      '&:hover': {
        backgroundColor: '#3F4B5F',
        color: '#49A6E5'
      }
    },
    noRadius: {
      borderRadius: 0
    },
    btnsGroup: {
      borderRadius: 4,
      overflow: 'hidden'
    }
  };
};
var _default = styles;
exports.default = _default;